// Sample gallery images - replace these with your actual image imports
import placeholder1 from '../img/Apartments/a-1.jpg';
import placeholder2 from '../img/Apartments/a-2.jpg';
import placeholder3 from '../img/Apartments/a-3.jpg';
import placeholder4 from '../img/Apartments/a-4.jpg';
import placeholder5 from '../img/Apartments/a-5.jpg';
import placeholder6 from '../img/Apartments/a-6.jpg';
import placeholder7 from '../img/Apartments/a-7.jpg';
import placeholder8 from '../img/Commercial/h-1.jpg';
import placeholder9 from '../img/Commercial/h-2.jpg';
import placeholder10 from '../img/Commercial/h-3.jpg';
import placeholder11 from '../img/Commercial/h-4.jpg';
import placeholder12 from '../img/Hospitality/h-1.jpg';
import placeholder13 from '../img/Hospitality/h-2.jpg';
import placeholder14 from '../img/Hospitality/h-3.jpg';
import placeholder15 from '../img/Industrial/i-1.jpg';
import placeholder16 from '../img/Institutional/i-1.jpg';
import placeholder17 from '../img/Institutional/i-2.jpg';
import placeholder18 from '../img/Interior-Design/1.jpg';
import placeholder19 from '../img/Interior-Design/i-8.jpg';
import placeholder20 from '../img/Interior-Design/02.jpg';
import placeholder21 from '../img/Interior-Design/4.jpg';
import placeholder22 from '../img/Interior-Design/004.jpg';
import placeholder23 from '../img/Interior-Design/5.jpg';
import placeholder24 from '../img/Interior-Design/i-1.jpg';
import placeholder25 from '../img/Interior-Design/i-4.jpg';
import placeholder26 from '../img/Interior-Design/i-2.jpg';
import placeholder27 from '../img/Interior-Design/i-6.jpg';
import placeholder28 from '../img/Interior-Design/001.jpg';
import placeholder29 from '../img/Master2Planning/m-1.jpg';
import placeholder30 from '../img/Master2Planning/m-2.jpg';
import placeholder31 from '../img/Master2Planning/m-3.jpg';
import placeholder32 from '../img/Master2Planning/m-4.jpg';
import placeholder33 from '../img/Master2Planning/m-5.jpg';
import placeholder34 from '../img/Religious/r-1.jpg';
import placeholder35 from '../img/Religious/001.jpg';
import placeholder36 from '../img/TechPark/t-1.jpg';
import placeholder37 from '../img/TechPark/t-2.jpg';
import placeholder38 from '../img/Villas/v-1.jpg';
import placeholder39 from '../img/Villas/v-2.jpg';
import placeholder40 from '../img/Villas/v-3.jpg';


import aasta1 from '../img/gallery/Aasta/1.jpg'
import aasta2 from '../img/gallery/Aasta/2.jpg'
import aasta3 from '../img/gallery/Aasta/3.jpg'
import aasta4 from '../img/gallery/Aasta/4.jpg'
import aasta5 from '../img/gallery/Aasta/5.jpg'
import aasta6 from '../img/gallery/Aasta/6.jpg'
import aasta7 from '../img/gallery/Aasta/7.jpg'
import aasta8 from '../img/gallery/Aasta/8.jpg'

import apas1 from '../img/gallery/apas/1.jpg';
import apas2 from '../img/gallery/apas/2.jpg';
import apas3 from '../img/gallery/apas/3.jpg';
import apas4 from '../img/gallery/apas/4.jpg';
import apas5 from '../img/gallery/apas/5.jpg';
import apas6 from '../img/gallery/apas/6.jpg';

import ner1 from '../img/gallery/NER/1.jpg';
import ner2 from '../img/gallery/NER/2.jpg';
import ner3 from '../img/gallery/NER/3.jpg';

import os1 from '../img/gallery/OS/1.jpg';
import os2 from '../img/gallery/OS/2.jpg';
import os3 from '../img/gallery/OS/3.jpg';
import os4 from '../img/gallery/OS/4.jpg';
import os5 from '../img/gallery/OS/5.jpg';
import os6 from '../img/gallery/OS/6.jpg';
import os7 from '../img/gallery/OS/7.jpg';

import re1 from '../img/gallery/RE/1.jpg';

import vv1 from '../img/gallery/VV/1.jpg';
import vv2 from '../img/gallery/VV/2.jpg';
import vv3 from '../img/gallery/VV/3.jpg';
import vv4 from '../img/gallery/VV/4.jpg';
import vv5 from '../img/gallery/VV/5.jpg';
import vv6 from '../img/gallery/VV/6.jpg';

import vvi1 from '../img/gallery/VVi/1.jpg';
import vvi2 from '../img/gallery/VVi/2.jpg';
import vvi3 from '../img/gallery/VVi/3.jpg';
import vvi4 from '../img/gallery/VVi/4.jpg';
import vvi5 from '../img/gallery/VVi/5.jpg';
import vvi6 from '../img/gallery/VVi/6.jpg';

//Commercial;

import hcc1 from '../img/gallery/hal/1.jpg';
import hcc2 from '../img/gallery/hal/2.jpg';
import hcc3 from '../img/gallery/hal/3.jpg';

import ne1 from '../img/gallery/NE/1.jpg';
import ne2 from '../img/gallery/NE/2.jpg';

import sr1 from '../img/Commercial/h-4.jpg';

import sinn1 from '../img/gallery/sinn/1.jpg';
import sinn2 from '../img/gallery/sinn/2.jpg';
import sinn3 from '../img/gallery/sinn/3.jpg';
import sinn4 from '../img/gallery/sinn/4.jpg';
import sinn5 from '../img/gallery/sinn/5.jpg';
import sinn6 from '../img/gallery/sinn/6.jpg';
import sinn7 from '../img/gallery/sinn/7.jpg';

import sur1 from '../img/gallery/sr/1.jpg';
import sur2 from '../img/gallery/sr/2.jpg';

import vss1 from '../img/gallery/vss/1.jpg';

import jsm1 from '../img/gallery/j-s-m/1.jpg';
import jsm2 from '../img/gallery/j-s-m/2.jpg';

import bcs1 from '../img/gallery/bcs/1.jpg';
import bcs2 from '../img/gallery/bcs/2.jpg';

import cca1 from '../img/gallery/cca/1.jpg'
import cca2 from '../img/gallery/cca/2.jpg';
import cca3 from '../img/gallery/cca/3.jpg';

import dsinn1 from '../img/gallery/dsinn/1.jpg';
import dsinn2 from '../img/gallery/dsinn/2.jpg';
import dsinn3 from '../img/gallery/dsinn/3.jpg';
import dsinn4 from '../img/gallery/dsinn/4.jpg';
import dsinn5 from '../img/gallery/dsinn/5.jpg';

import vsr1 from '../img/gallery/vsr/1.jpg';
import vsr2 from '../img/gallery/vsr/2.jpg';

import ram1 from '../img/gallery/r-a-m/1.jpg';
import ram2 from '../img/gallery/r-a-m/2.jpg';
import ram3 from '../img/gallery/r-a-m/3.jpg';
import ram4 from '../img/gallery/r-a-m/4.jpg';
import ram5 from '../img/gallery/r-a-m/5.jpg';

import gym1 from '../img/gallery/gym/1.jpg';
import gym2 from '../img/gallery/gym/2.jpg';
import gym3 from '../img/gallery/gym/3.jpg';
import gym4 from '../img/gallery/gym/4.jpg';
import gym5 from '../img/gallery/gym/5.jpg';

import rosr1 from '../img/gallery/rosr/1.jpg';
import rosr2 from '../img/gallery/rosr/2.jpg';
import rosr3 from '../img/gallery/rosr/3.jpg';
import rosr4 from '../img/gallery/rosr/4.jpg';
import rosr5 from '../img/gallery/rosr/5.jpg';
import rosr6 from '../img/gallery/rosr/4.jpg';
import rosr7 from '../img/gallery/rosr/5.jpg';

export const galleryItems = [
	{
		id: 1,
		title: ' Aastha',
		image: placeholder1,
		images: [
			{
				urls: aasta1,
			},
			{
				urls: aasta2,
			},
			{
				urls: aasta3,
			},
			{
				urls: aasta4,
			},
			{
				urls: aasta5,
			},
			{
				urls: aasta6,
			},
			{
				urls: aasta7,
			},
			{
				urls: aasta8,
			},
		],
		category: 'Apartments',
		description: '',
	},
	{
		id: 2,
		title: ' Apas',
		image: placeholder2,
		images: [
			{
				urls: apas1,
			},
			{
				urls: apas2,
			},
			{
				urls: apas3,
			},
			{
				urls: apas4,
			},
			{
				urls: apas5,
			},
			{
				urls: apas6,
			},
		],
		category: 'Apartments',
		description: '',
	},
	{
		id: 3,
		title: 'N E Realcons',
		image: placeholder3,
		images: [
			{
				urls: ner1,
			},
			{
				urls: ner2,
			},
			{
				urls: ner3,
			},
		],
		category: 'Apartments',
		description: '',
	},
	{
		id: 4,
		title: 'Orchard Square',
		image: placeholder4,
		images: [
			{
				urls: os1,
			},
			{
				urls: os2,
			},
			{
				urls: os3,
			},
			{
				urls: os4,
			},
			{
				urls: os5,
			},
			{
				urls: os6,
			},
			{
				urls: os7,
			},
		],
		category: 'Apartments',
		description: '',
	},
	{
		id: 5,
		title: 'Rythym Estate',
		image: placeholder5,
		images: [
			{
				urls: re1,
			},
		],
		category: 'Apartments',
		description: '',
	},
	{
		id: 6,
		title: 'Vedant Vayun',
		image: placeholder6,
		images: [
			{
				urls: vv1,
			},
			{
				urls: vv2,
			},
			{
				urls: vv3,
			},
			{
				urls: vv4,
			},
			{
				urls: vv5,
			},
			{
				urls: vv6,
			},
		],
		category: 'Apartments',
		description: '',
	},
	{
		id: 7,
		title: 'Vedant Vihas',
		image: placeholder7,
		images: [
			{
				urls: vvi1,
			},
			{
				urls: vvi2,
			},
			{
				urls: vvi3,
			},
			{
				urls: vvi4,
			},
			{
				urls: vvi5,
			},
			{
				urls: vvi6,
			},
		],
		category: 'Apartments',
		description: '',
	},
	{
		id: 8,
		title: 'HAL Commercial Complex',
		image: placeholder8,
		images: [
			{
				urls: hcc1,
			},
			{
				urls: hcc2,
			},
			{
				urls: hcc3,
			},
		],
		category: 'Commercial',
		description: '',
	},
	{
		id: 9,
		title: 'Manu Complex',
		image: placeholder9,
		images: [
			{
				urls: hcc1,
			},
			{
				urls: hcc2,
			},
			{
				urls: hcc3,
			},
		],
		category: 'Commercial',
		description: '',
	},
	{
		id: 10,
		title: 'NE Realcons',
		image: placeholder10,
		images: [
			{
				urls: ne1,
			},
			{
				urls: ne2,
			},
		],
		category: 'Commercial',
		description: '',
	},
	{
		id: 11,
		title: 'Suvarna Resort',
		image: placeholder11,
		images: [
			{
				urls: sr1,
			},
		],
		category: 'Commercial',
		description: '',
	},

	{
		id: 12,
		title: 'SSuvarna Inn',
		image: placeholder12,
		images: [
			{
				urls: sinn1,
			},
			{
				urls: sinn2,
			},
			{
				urls: sinn3,
			},
			{
				urls: sinn4,
			},
			{
				urls: sinn5,
			},
			{
				urls: sinn6,
			},
			{
				urls: sinn7,
			},
		],
		category: 'Hospitality',
		description: '',
	},
	{
		id: 13,
		title: 'Suvarna Regency',
		image: placeholder13,
		images: [
			{
				urls: sur1,
			},
			{
				urls: sur2,
			},
		],
		category: 'Hospitality',
		description: '',
	},
	{
		id: 14,
		title: 'Valmark Starlit Suites',
		image: placeholder14,
		images: [
			{
				urls: vss1,
			},
		],
		category: 'Hospitality',
		description: '',
	},
	{
		id: 15,
		title: 'Johnson & Smith',
		image: placeholder15,
		images: [
			{
				urls: jsm1,
			},
			{
				urls: jsm2,
			},
		],
		category: 'Industrial',
		description: '',
	},
	{
		id: 16,
		title: 'BVRIT – CS & IT Block',
		image: placeholder16,
		images: [
			{
				urls: bcs1,
			},
			{
				urls: bcs2,
			},
		],
		category: 'Institutional',
		description: '',
	},
	{
		id: 17,
		title: 'City College Auditorium',
		image: placeholder17,
		images: [
			{
				urls: cca1,
			},
			{
				urls: cca2,
			},
			{
				urls: cca3,
			},
		],
		category: 'Institutional',
		description: '',
	},
	{
		id: 18,
		title: 'Suvarna Inn',
		image: placeholder18,
		images: [
			{
				urls: dsinn1,
			},
			{
				urls: dsinn2,
			},
			{
				urls: dsinn3,
			},
			{
				urls: dsinn4,
			},
			{
				urls: dsinn5,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 19,
		title: 'Villa at Sarjapur Road',
		image: placeholder19,
		images: [
			{
				urls: vsr1,
			},
			{
				urls: vsr2,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 20,
		title: 'Office of MG Road',
		image: placeholder20,
		images: [
			{
				urls: placeholder20,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 21,
		title: 'Residence at Mathikere',
		image: placeholder21,
		images: [
			{
				urls: ram1,
			},
			{
				urls: ram2,
			},
			{
				urls: ram3,
			},
			{
				urls: ram4,
			},
			{
				urls: ram5,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 22,
		title: 'Gym at Koramangala',
		image: placeholder22,
		images: [
			{
				urls: gym1,
			},
			{
				urls: gym2,
			},
			{
				urls: gym3,
			},
			{
				urls: gym4,
			},
			{
				urls: gym5,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 23,
		title: 'Residence of Sarjapura Road',
		image: placeholder23,
		images: [
			{
				urls: rosr1,
			},
			{
				urls: rosr2,
			},
			{
				urls: rosr3,
			},
			{
				urls: rosr4,
			},
			{
				urls: rosr5,
			},
			{
				urls: rosr6,
			},
			{
				urls: rosr7,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 24,
		title: 'Aastha Club House',
		image: placeholder24,
		images: [
			{
				urls: placeholder24,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 25,
		title: 'Hotel Owner’s Pvt Cabin',
		image: placeholder25,
		images: [
			{
				urls: placeholder25,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 26,
		title: 'Apartment Interiors',
		image: placeholder26,
		images: [
			{
				urls: placeholder26,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 27,
		title: 'Residence at Sahakarnagar',
		image: placeholder27,
		images: [
			{
				urls: placeholder27,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 28,
		title: 'Club of Bannergatta Road',
		image: placeholder28,
		images: [
			{
				urls: placeholder28,
			},
		],
		category: 'Interior Design',
		description: '',
	},
	{
		id: 29,
		title: 'RNS',
		image: placeholder29,
		images: [
			{
				urls: placeholder29,
			},
		],
		category: 'Master Planning',
		description: '',
	},
	{
		id: 30,
		title: 'Kent Novella',
		image: placeholder30,
		images: [
			{
				urls: placeholder30,
			},
		],
		category: 'Master Planning',
		description: '',
	},
	{
		id: 31,
		title: 'Allamara',
		image: placeholder31,
		images: [
			{
				urls: placeholder31,
			},
		],
		category: 'Master Planning',
		description: '',
	},
	{
		id: 32,
		title: 'Allamara',
		image: placeholder32,
		images: [
			{
				urls: placeholder32,
			},
		],
		category: 'Master Planning',
		description: '',
	},
	{
		id: 33,
		title: 'Allamara',
		image: placeholder33,
		images: [
			{
				urls: placeholder33,
			},
		],
		category: 'Master Planning',
		description: '',
	},
	{
		id: 34,
		title: 'Evangelical Out Reach Mission',
		image: placeholder34,
		images: [
			{
				urls: placeholder34,
			},
		],
		category: 'Religious',
		description: '',
	},
	{
		id: 35,
		title: 'St Pauls Central Methodist',
		image: placeholder35,
		images: [
			{
				urls: placeholder35,
			},
		],
		category: 'Religious',
		description: '',
	},
	{
		id: 36,
		title: 'Tech Park Night',
		image: placeholder36,
		images: [
			{
				urls: placeholder36,
			},
		],
		category: 'Tech Park',
		description: '',
	},
	{
		id: 37,
		title: 'Tech Park',
		image: placeholder37,
		images: [
			{
				urls: placeholder37,
			},
		],
		category: 'Tech Park',
		description: '',
	},
	{
		id: 38,
		title: 'Kent',
		image: placeholder38,
		images: [
			{
				urls: placeholder38,
			},
		],
		category: 'Villas',
		description: '',
	},
	{
		id: 39,
		title: 'RBD',
		image: placeholder39,
		images: [
			{
				urls: placeholder39,
			},
		],
		category: 'Villas',
		description: '',
	},
	{
		id: 40,
		title: 'Villa vigne',
		image: placeholder40,
		images: [
			{
				urls: placeholder40,
			},
		],
		category: 'Villas',
		description: '',
	},
	// {
	// 	id: 4,
	// 	title: 'Brand Identity',
	// 	image: placeholder4,
	// 	images: [
	// 		{
	// 			urls: placeholder4,
	// 			title: 'Brand Identity',
	// 			description: 'Complete brand identity design - Logo',
	// 		},
	// 		{
	// 			urls: placeholder6,
	// 			title: 'Brand Identity',
	// 			description: 'Complete brand identity design - Guidelines',
	// 		},
	// 	],
	// 	category: 'branding',
	// 	description: 'Complete brand identity design',
	// },
	// {
	// 	id: 6,
	// 	title: 'Motion Graphics',
	// 	image: placeholder6,
	// 	images: [
	// 		{
	// 			urls: placeholder6,
	// 			title: 'Motion Graphics',
	// 			description: 'Motion graphics and animation - Frame 1',
	// 		},
	// 		{
	// 			urls: placeholder2,
	// 			title: 'Motion Graphics',
	// 			description: 'Motion graphics and animation - Frame 2',
	// 		},
	// 	],
	// 	category: 'video',
	// 	description: 'Motion graphics and animation',
	// },
	// {
	// 	id: 7,
	// 	title: 'Illustration Art',
	// 	image: placeholder7,
	// 	images: [
	// 		{
	// 			urls: placeholder7,
	// 			title: 'Illustration Art',
	// 			description: 'Custom illustration artwork - Sketch 1',
	// 		},
	// 		{
	// 			urls: placeholder2,
	// 			title: 'Illustration Art',
	// 			description: 'Custom illustration artwork - Sketch 2',
	// 		},
	// 		{
	// 			urls: placeholder3,
	// 			title: 'Illustration Art',
	// 			description: 'Custom illustration artwork - Final Art',
	// 		},
	// 	],
	// 	category: 'illustration',
	// 	description: 'Custom illustration artwork',
	// },
	// {
	// 	id: 8,
	// 	title: 'Portrait Photography',
	// 	image: placeholder8,
	// 	images: [
	// 		{
	// 			urls: placeholder8,
	// 			title: 'Portrait Photography',
	// 			description: 'Professional portrait shots - Portrait 1',
	// 		},
	// 		{
	// 			urls: placeholder3,
	// 			title: 'Portrait Photography',
	// 			description: 'Professional portrait shots - Portrait 2',
	// 		},
	// 	],
	// 	category: 'photography',
	// 	description: 'Professional portrait shots',
	// },
];

export const galleryCategories = [
	'Apartments',
	'Commercial',
	'Hospitality',
	'Industrial',
	'Institutional',
	'Interior Design',
	'Master Planning',
	'Religious',
	'Tech Park',
	'Villas',
];
